// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Edit: React.FC<{ width?: number; height?: number }> = ({ width = 13, height = 13 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
            <path
                fill="currentColor"
                d="M11.0625 1.015625C10.546875 0.5 9.703125 0.5 9.1875 1.015625L8.625 1.578125L10.921875 3.875L11.484375 3.3125C12 2.796875 12 1.953125 11.484375 1.4375L11.0625 1.015625ZM4.03125 6.171875C3.890625 6.3125 3.796875 6.4765625 3.7265625 6.6875L3.0234375 8.75C2.953125 8.9609375 3.0234375 9.1953125 3.1640625 9.3359375C3.328125 9.5 3.5390625 9.546875 3.75 9.4765625L5.8359375 8.7734375C6.0234375 8.7265625 6.1875 8.609375 6.328125 8.46875L10.125 4.671875L7.828125 2.375L4.03125 6.171875ZM2.25 2C1.0078125 2 0 3.0078125 0 4.25L0 10.25C0 11.492188 1.0078125 12.5 2.25 12.5L8.25 12.5C9.4921875 12.5 10.5 11.492188 10.5 10.25L10.5 8C10.5 7.578125 10.171875 7.25 9.75 7.25C9.328125 7.25 9 7.578125 9 8L9 10.25C9 10.671875 8.671875 11 8.25 11L2.25 11C1.828125 11 1.5 10.671875 1.5 10.25L1.5 4.25C1.5 3.828125 1.828125 3.5 2.25 3.5L4.5 3.5C4.921875 3.5 5.25 3.171875 5.25 2.75C5.25 2.328125 4.921875 2 4.5 2L2.25 2Z"
            />
        </svg>
    );
};

export default React.memo(Edit);
